import React from 'react';
import './styles/About.css';
import { Link } from 'react-router-dom';

function About() {
    return(
        <div className='aboutContainer'>
            <div className='aboutContentContainer'>

                <div className='aboutTextContainer'>
                    <h1>Über Uns</h1>
                    <h2>Schreberjugend- macht Spaß und bildet grenzenlos!</h2>
                    <p>Streberjugend? Schreiberjugend? … ach Schreberjugend! Was ist das denn?</p>
                    <p>SCHREBERjugend- da kommen doch spontan die SCHREBERgärten in den Sinn. Die Schreberjugend Südwest hat als historisch gewachsener Jugendverband seine Wurzeln tatsächlich in der Kleingartenbewegung und den Schrebervereinen.</p>
                    <p>Heute fühlen wir uns diesen Wurzeln durch den Schwerpunkt unserer Arbeit immer noch eng verbunden. Wir möchten Kindern und Jugendlichen die Möglichkeit bieten, in der Natur gesundheitlich, naturkundlich, sportlich und kulturell aktiv zu werden.</p>
                    <p>Schreberjugend heute…</p>
                    <p>… macht Spaß bei den vielfältigen Angeboten zu denen ehrenamtliche Kinder- und Jugendarbeit, Ferienreisen und Seminare gehören.</p>
                    <p>… und bildet grenzenlos, beispielsweise innerhalb der Seminar- und Fortbildungsangebote, der außerschulichen Bildungsarbeit oder der Natur- und Umwelterziehung.</p>
                    <p>Wir streben an, mit unseren Angeboten Kinder und Jugendliche zu selbstbestimmtem und eigenverantwortlichem Handeln zu motivieren, die Kompetenzen durch unsere vielfältigen Aktivitäten und Bildungsangebote zu erweitern, und unter den Aspekten von verantwortlichem Handeln gegenüber der Umwelt- Mensch und Natur- Horizonte und Grenzen zu erweitern.</p>
                    <h2>Das Zeltlager-Team</h2>
                    <p>Jedes Jahr findet sich ein bunt gemischtes Team ehrenamtlicher Betreuerinnen und Betreuer zusammen, die ihren Jahresurlaub und ihre freie Zeit gerne für eine gute Sache einsetzen und das Zeltlager so erst möglich machen.</p>
                    <p>Mit Kreativität, Begeisterungsfähigkeit und Engegament planen wir das Zeltlager in einem intensiven Vorbereitungswochenende und das ganze Jahr über, um den Teilnehmenden erlebnisreiche vierzehn Tage zu bieten.</p>
                </div>
            </div>
            <div className='bottomContainer'>
                    <Link to='https://deutsche-schreberjugend.de/'>
                        <p> Deutsche Schreberjugend</p>
                    </Link>
                    <Link to={'/impressum'}>
                        <p>Impressum</p>
                    </Link>
                    <Link to={'/datenschutz'}>
                        <p>Datensschutz</p>
                    </Link>
            </div>
        </div>
    );
}

export default About;